import React from 'react';

// this svg is wrapped in a component because it was breaking on compile
export default function OverlayIconSvg(props: {className?: string}) {
  const { className } = props;
  return (
    <svg width="35" height="35" viewBox="0 0 45 45" className={className}>
      <defs>
        <filter x="-16.3%" y="-11.6%" width="132.6%" height="132.6%" filterUnits="objectBoundingBox" id="a">
          <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feColorMatrix values="0 0 0 0 0.366791214 0 0 0 0 0.366791214 0 0 0 0 0.366791214 0 0 0 0.29419799 0" in="shadowBlurOuter1" />
        </filter>
      </defs>
      <g fillRule="evenodd">
        <path d="M21.5 0C33.374 0 43 9.626 43 21.5S33.374 43 21.5 43 0 33.374 0 21.5 9.626 0 21.5 0zm5.614 11.467H16.603a3.177 3.177 0 00-3.177 3.177v16.818l.01.15a1.076 1.076 0 001.69.724l6.732-4.81 6.733 4.81c.712.509 1.7 0 1.7-.874V14.644a3.177 3.177 0 00-3.177-3.177z" opacity="0.822" fill="#FFF" className="outer-circle" />
        <path d="M27.114 11.467H16.603a3.177 3.177 0 00-3.177 3.177v16.818l.01.15a1.076 1.076 0 001.69.724l6.732-4.81 6.733 4.81c.712.509 1.7 0 1.7-.874V14.644a3.177 3.177 0 00-3.177-3.177z" fill="transparent" fillRule="nonzero" className="bookmark-cutout" />
      </g>
    </svg>
  );
}
